import { useNavigate } from 'react-router-dom';
import { VehicleForm } from './Vehicles';
import { ArrowLeft } from 'lucide-react';

export const VehicleNew = () => {
  const navigate = useNavigate();
  return (
    <div className="page">
      <div className="page-header">
        <div>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/vehicles')} style={{ marginBottom: 8 }}><ArrowLeft size={14} /> Back</button>
          <div className="page-title">Add New Vehicle</div>
        </div>
      </div>
      <div className="card">
        <VehicleForm onSave={() => navigate('/vehicles')} onCancel={() => navigate('/vehicles')} />
      </div>
    </div>
  );
};
